<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, getCurrentInstance } from "vue";
import CommonVTimeLineDay from "@/components/common/VTimeLineDay.vue";
import { getSiteData, goBack } from "@/NavigationHelper";
import { mountedBase, BaseSetup } from "@/DataLoaderStatic";
import { checkBegriff } from "@/local";
const emit = defineEmits(["back"]);
const siteData = getSiteData();
let myHeight = ref<number>(900);
let day = ref<Date>(new Date(siteData?.zeitbereich.von)) ?? new Date();
let titel: string = siteData.title;
let name = ref<string>(siteData.name ?? "");
let showNacherfassung = ref<boolean>(false);
let showTagessaldo = ref<boolean>(false);
let showProjektstunden = ref<boolean>(false);
let myWidth = ref<number>(450);

function onRefresh() {
  const instance = getCurrentInstance();
  if (instance) {
    (instance.proxy?.$refs.timelines as any).onRefresh();
  }
}
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (window.innerWidth < 600) {
    myWidth.value = window.innerWidth - 10;
  }
  if (siteData.aic) {
    pageParams.aic = siteData.aic;
  }
  if (checkBegriff("Web_VG_InfoAnzeigen")) {
    showTagessaldo.value = true;
  }
  if (checkBegriff("PZE_Web_WF_VG_Projektstunden")) {
    showProjektstunden.value = true;
  }
  if (checkBegriff("Web_KorrekturStempelungen") || siteData?.showNew) {
    showNacherfassung.value = true;
  }

  await mountedBase(uiData, pageParams, false);
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template>
  <v-card
    :loading="uiData.showLoading"
    class="pa-0"
    max-width="450px"
    :max-height="myHeight - 10"
  >
    <CommonVTimeLineDay
      v-if="uiData.initialized"
      query="WebStempelungenSoftTerm"
      :contentHeight="myHeight - 120"
      :contentWidth="myWidth"
      ref="timeline"
      :showError="true"
      :showTagessaldo="showTagessaldo"
      :showNacherfassung="showNacherfassung"
      :showProjektstunden="showProjektstunden"
      :showReisekosten="false"
      queryEdit="Web_TimeLineStempelungen"
      :day="day"
      :showClose="false"
      class="pa-0"
      :aic="siteData.aic"
      :freigabeAntrag="true"
      :showName="true"
      :nameUebergabe="name"
      :admin="siteData.admin"
      :showManZulagen="siteData.showManZulagen"
    />

    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn variant="text" color="primary" @click="goBack()" icon="mdi-close"></v-btn>
    </v-card-actions> -->
  </v-card>
</template>
<style scoped></style>
